import React from 'react';
import {CloseButton, Col, Modal, Row, Table} from "react-bootstrap";
import {useSelector} from "react-redux";
import {selectLang, selectNumberFormat, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import SoftBadge from "../../../common/SoftBadge";

const ShowInvoiceMarkValidateModal = ({setShow, data}) => {

    const lang = useSelector(selectLang);
    const t = Translate;
    const numberFormat = useSelector(selectNumberFormat);

    const handleClose = () => {
        setShow(false);
    }

    return (
        <Modal show={true} onHide={handleClose} fullscreen>
            <Modal.Header>
                <CloseButton onClick={handleClose}/>
            </Modal.Header>
            <Modal.Body>
                <h5 className={'text-center'}>{t(lang, "roaming.invoice.mark.validate.modal.general.info")}</h5>
                <Row>
                    <Col md={12} lg={6}>
                        <SoftBadge bg='success' className='d-block py-2'>
                            <div className={'d-flex fs-1 gap-2 justify-content-center text-facebook'}>
                                <span>{t(lang, "roaming.invoice.mark.validate.modal.found.title")}:</span>
                                <div>
                                    <span>{numeral?.formats[numberFormat]?.format(data?.cis_product_count)?.replace(/\.00$/, '')}/</span>
                                    <span>{numeral?.formats[numberFormat]?.format(data?.invoice_marking_quantity)?.replace(/\.00$/, '')}</span>
                                </div>
                                <span>({numeral?.formats[numberFormat]?.format((data?.cis_product_count / data?.invoice_marking_quantity) * 100)?.replace(/\.00$/, '')}%)</span>
                            </div>
                        </SoftBadge>
                    </Col>
                    <Col md={12} lg={6}>
                        <SoftBadge bg='danger' className='d-block py-2'>
                            <div className={'d-flex fs-1 gap-2 justify-content-center text-facebook'}>
                                <span>{t(lang, "roaming.invoice.mark.validate.modal.notfound.title")}:</span>
                                <div>
                                    <span>{numeral?.formats[numberFormat]?.format(data?.invoice_marking_quantity - data?.cis_product_count)?.replace(/\.00$/, '')}/</span>
                                    <span>{numeral?.formats[numberFormat]?.format(data?.invoice_marking_quantity)?.replace(/\.00$/, '')}</span>
                                </div>
                                <span>({numeral?.formats[numberFormat]?.format(((data?.invoice_marking_quantity - data?.cis_product_count) / data?.invoice_marking_quantity) * 100)?.replace(/\.00$/, '')}%)</span>
                            </div>
                        </SoftBadge>
                    </Col>
                </Row>
                <hr/>
                <Row className={'mb-2'}>
                    <Col md={12} lg={6}>
                        <h5 className={'text-center'}>{t(lang, "roaming.invoice.mark.validate.modal.statistics_by_statuses")}</h5>
                        <div className={'d-flex flex-column gap-2'}>
                            {data?.group_by_status.map((item, index) => {
                                return (
                                    <SoftBadge bg='secondary' className='d-block py-2' key={index}>
                                        <div className={'d-flex fs-1 gap-2 justify-content-center text-facebook'}>
                                            {item?.description}:
                                            <div>
                                                <span className={'ms-2'}>{numeral?.formats[numberFormat]?.format(item?.count)?.replace(/\.00$/, '')}/</span>
                                                <span>{numeral?.formats[numberFormat]?.format(data?.cis_product_count)?.replace(/\.00$/, '')}</span>
                                            </div>
                                        </div>
                                    </SoftBadge>
                                )
                            })}
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <h5 className={'text-center'}>{t(lang, "roaming.invoice.mark.validate.modal.owner_statuses")}</h5>
                        <div className={'d-flex flex-column gap-2'}>
                            {data?.group_by_owner.map((item, index) => {
                                return (
                                    <SoftBadge bg='secondary' className='d-block py-2' key={index}>
                                        <div className={'d-flex fs-1 gap-2 justify-content-center text-facebook'}>
                                            {item.description}:
                                            <div>
                                                <span className={'ms-2'}>{numeral?.formats[numberFormat]?.format(item.count)?.replace(/\.00$/, '')} /</span>
                                                <span>{numeral?.formats[numberFormat]?.format(data?.cis_product_count)?.replace(/\.00$/, '')}</span>
                                            </div>
                                        </div>
                                    </SoftBadge>
                                )
                            })}
                        </div>
                    </Col>
                </Row>
                {
                    data &&
                    <Table striped bordered>
                        <thead className={'bg-soft-secondary'}>
                        <tr>
                            <th style={{width: 30}}>{t(lang, "№")}</th>
                            <th style={{minWidth: 300, maxWidth: 350}}>{t(lang, "roaming.invoice.mark.validate.modal.product_name")}</th>
                            <th>{t(lang, "edi.contract_formation.excel.column_type_barcode")}</th>
                            <th>{t(lang, "edi.contract_formation.excel.column_type_quantity")}</th>
                            <th>{t(lang, "roaming.invoice.mark.validate.modal.has_marking")}</th>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data?.items?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th>{index + 1}</th>
                                        <th>{item.product_name}</th>
                                        <th>{item.barcode}</th>
                                        <th>
                                            <div className={'d-flex gap-1'}>
                                                <span className={'text-success'}>
                                                    {numeral?.formats[numberFormat]?.format(item.cis_product_count)?.replace(/\.00$/, '')}
                                                </span>
                                                /
                                                <span className={'text-primary'}>
                                                    {numeral?.formats[numberFormat]?.format(item.quantity)?.replace(/\.00$/, '')}
                                                </span>
                                            </div>
                                        </th>
                                        <th>
                                            {
                                                item.has_marking ? t(lang, "edi.common.button.yes") : t(lang, "edi.common.button.no")
                                            }
                                        </th>
                                        <th>
                                            {item.cis_product_count_quantity_miss_match &&
                                                <FontAwesomeIcon
                                                    size={'lg'}
                                                    className="text-danger"
                                                    icon={"exclamation-circle"}
                                                />
                                            }
                                        </th>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                }
            </Modal.Body>
        </Modal>
    );
};

export default ShowInvoiceMarkValidateModal;